// import _BaseAPIService from "../_BaseAPIService";

// const apiService = _BaseAPIService.instance;

// const ComplimentryService = {
//   getAll: async () => {
//     const response = await apiService.get(`/complimentrylogs/filter`);
//     return response.data;
//   },
//    getGrpItem: async () => {
//     const response = await apiService.get(`/complimentrylogs/grouped`);
//     return response.data;
//   },
//   detail: async (orderId) => {
//     const response = await apiService.get(
//       `/complimentrylogs/by-order/${orderId}`
//     );
//     return response.data;
//   },
// };

// export default ComplimentryService;


import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const ComplimentryService = {
  getAll: async ({ page = 1, pageSize = 10, itemName = "", itemId = null, startDate = null, endDate = null }) => {
    const params = {
      page,
      pageSize,
      itemName,
      itemId,
      startDate,
      endDate,
    };

    const response = await apiService.get("/complimentrylogs/filter", { params });
    return response.data;
  },
  
    getByOrder: async (orderId) => {
    const response = await apiService.get(`/complimentrylogs/by-order/${orderId}`);
    return response.data; // response is array
  },
  
  getGrpItem: async () => {
    const response = await apiService.get(`/complimentrylogs/grouped`);
    return response.data;
  },

  detail: async (orderId) => {
    const response = await apiService.get(`/complimentrylogs/by-order/${orderId}`);
    return response.data;
  },
};

export default ComplimentryService;

